import * as Sentry from '@sentry/react';

/**
 * extracted from
 * http://bugs.goibibo.com/sentry/avataar/getting-started/javascript-react/
 *
 * and
 *
 * http://bugs.goibibo.com/sentry/avatar/getting-started/javascript-react/
 *
 * respectively
 *
 * @Note
 * Ideally this should live in application config. But there's a webpack error
 * while trying to include this varible from application-config.
 */
export const sentryUrl = {
  'aerial-dweb':
    'https://3b74eb7da21f49a9b3f8fe2e94ee8048@o162542.ingest.sentry.io/4505044745453568',
  'aerial-mweb':
    'https://1fb37eb3f89c41dab0497f954c42e7ad@o162542.ingest.sentry.io/4505044764262400',
  'aerial-seo-dweb':
    'https://9b305110d03b467da0ce2379dabb50d9@o162542.ingest.sentry.io/4505044780318720',
  'aerial-seo-mweb':
    'https://915dbb572b74421ba490678b1f5644ed@o162542.ingest.sentry.io/4505044789886976',
  'aerial-mweb-lite':
    'https://fd8a44aaa4a34c0190d7435ea366d755@o162542.ingest.sentry.io/4505044849852416'
};

export default function initSentry({ appName = '' }) {
  const dsn = sentryUrl[appName];

  if (dsn) {
    Sentry.init({
      dsn,
      integrations: [new Sentry.BrowserTracing()],
      autoSessionTracking: true,
      // this is customisable based on different transactions
      // read more at https://docs.sentry.io/platforms/javascript/guides/react/configuration/filtering/#sampling-transaction-events
      tracesSampleRate: __ENV_CONFIG__ && __ENV_CONFIG__?.ENV === 'prod' ? 0.1 : 1.0,
      ignoreErrors: [
        // Random plugins/extensions
        'top.GLOBALS'
      ],
      denyUrls: [
        // Facebook blocked
        /connect\.facebook\.net\/en_US\/all\.js/i,
        // Chrome extensions
        /extensions\//i,
        /^chrome:\/\//i
      ]
    });
  }
}
